<template>
  <a-modal v-model:visible="navVisible" :title="`${dealName}`" @ok="() => {}">
    <a-tabs v-model:activeKey="navActiveTab">
      <a-tab-pane key="1" tab="常规导航配置">
        <div v-if="searchParams.terminalId === 1" class="mt20">
          <div class="mb10"><span class="red">*</span>PC端导航：</div>
          <div class="mb20">
            <a-select
              v-model:value="pcActiveIdVal"
              :options="pcOptions"
              style="width: 200px"
              placeholder="请选择"
              @change="
                (val, option) => {
                  const oldId = pcActiveId
                  pcActiveId = option.id
                  getNav(dealName, 1, false, oldId)
                }
              "
            />
          </div>
          <div class="mb10"><span class="red">*</span>M端导航：</div>
          <div class="mb20">
            <a-select
              v-model:value="mActiveIdVal"
              :options="mOptions"
              style="width: 200px"
              placeholder="请选择"
              @change="
                (val, option) => {
                  const oldId = mActiveId
                  mActiveId = option.id
                  getNav(dealName, 2, false, oldId)
                }
              "
            />
          </div>
        </div>
        <div v-else class="mt20">
          <div class="mb10"><span class="red">*</span>导航：</div>
          <div class="mb20">
            <a-select
              v-model:value="appActiveIdVal"
              :options="appOptions"
              style="width: 200px"
              placeholder="请选择"
              @change="
                (val, option) => {
                  const oldId = appActiveId
                  appActiveId = option.id
                  getNav(dealName, -1, false, oldId)
                }
              "
            />
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="品牌升级场景配置">
        <div v-if="searchParams.terminalId === 1" class="mt20">
          <div class="mb10"><span class="red">*</span>PC端导航：</div>
          <div class="mb20">
            <a-select
              v-model:value="pcActiveIdVal"
              :options="pcOptions"
              style="width: 200px"
              placeholder="请选择"
              @change="
                (val, option) => {
                  const oldId = pcActiveId
                  pcActiveId = option.id
                  getNav(dealName, 1, false, oldId)
                }
              "
            />
          </div>
          <div class="mb10"><span class="red">*</span>M端导航：</div>
          <div class="mb20">
            <a-select
              v-model:value="mActiveIdVal"
              :options="mOptions"
              style="width: 200px"
              placeholder="请选择"
              @change="
                (val, option) => {
                  const oldId = mActiveId
                  mActiveId = option.id
                  getNav(dealName, 2, false, oldId)
                }
              "
            />
          </div>
        </div>
        <div v-else class="mt20">
          <div class="mb10"><span class="red">*</span>导航：</div>
          <div class="mb20">
            <a-select
              v-model:value="appActiveIdVal"
              :options="appOptions"
              style="width: 200px"
              placeholder="请选择"
              @change="
                (val, option) => {
                  const oldId = appActiveId
                  appActiveId = option.id
                  getNav(dealName, -1, false, oldId)
                }
              "
            />
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
    <template #footer>
      <div>
        <a-button type="default" @click="cancelNav">取消</a-button>
        <a-button type="primary" @click="saveActive">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>
<script>
import { toRefs, inject, watch } from 'vue'
export default {
  setup() {
    const initState = inject('initState')
    // const navActiveTab = ref('1')
    watch(
      () => initState.navVisible,
      val => {
        if (val) {
          initState.navActiveTab = '1'
        }
      }
    )
    return {
      ...toRefs(initState)
      // navActiveTab
    }
  }
}
</script>
